import styled, { keyframes } from "styled-components";

const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.2; }
  100% { opacity: 1; }
`;



export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  text-align: center;
  gap: 8px;
  margin-top: -3.5rem;
  padding-right: 0.7rem;
  pointer-events: none;

  @media (max-width: 768px) {
    gap: 2rem ;
  }

  

  .file-name{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    pointer-events: all;
    position: absolute;
    bottom: -60px;

    img {
      width: 13px;
      margin: 0 2px 0 5px;
      filter: invert(100%) sepia(100%) saturate(100%) brightness(100%) contrast(100%);
    }

    strong{
      cursor: pointer;
    }

    @media (max-width: 768px) {
    width: 90%;
    }
  }
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 10px;
  width: 42vw;
  position: absolute;
  right: 3vh;
  bottom: -35px;

  img {
    width: 2rem;
    margin: 0.3rem 0 0 0;
    cursor: pointer;
    color: white;
    pointer-events: all;
    filter: invert(45%) sepia(45%) saturate(45%) brightness(100%) contrast(100%);
  }


  @media (max-width: 768px) {
    width: 76vw;
  }
`;

export const Modal = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;

  header{
    background-color: var(--primary-blue);
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
  }
`;

export const VideoBox = styled.div`
  background: var(--white);
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px;
  position: relative;

  @media (max-width: 768px) {
    width: 90vw;
  }



  video {
    width: 400px;
    height: 300px;
    background: black;

    @media (max-width: 768px) {
      width: 80vw;
      height: auto;
    }
  }

   
  .video-buttons {
    display: flex;
    gap: 10px;
    justify-content: end;
    pointer-events: all;

    img{
      width: 20px;
      filter: invert(45%) sepia(45%) saturate(45%) brightness(999%) contrast(999%);
    }

  }

  .video-button{
    display: flex;
    background-color: var(--primary-blue);
    padding: 5px 10px;
    border-radius: 2px;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
  }
  .video-button:hover{
    background-color: var(--light-blue);
  }
`;

export const RecIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: red;
  font-weight: bold;
  font-size: 18px;

  .dot {
    width: 12px;
    height: 12px;
    background: red;
    border-radius: 50%;
    animation: ${blink} 0.8s infinite;
  }
`;
